import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

// Language services
import { i18n, initI18n } from '@zippeditoolsjs/translations';
import { I18nextProvider } from 'react-i18next';

import es from './i18n/es.json';
import en from './i18n/en.json';
import de from './i18n/de.json';

initI18n(en, es, null, { de });

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// To log results (for example: reportWebVitals(console.log))
// Or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
